/**
 * 選択されたセレクターに対応する要素を全て返す。
 *
 * @param selector セレクター
 * @param context ルートとする要素 指定されていない場合はdocument
 * @returns HTML要素の配列
 */
export const pickElements = <T extends HTMLElement>(selector: string, context?: Element) => {
    const elems = (context ?? document).querySelectorAll<T>(selector);
    if (elems.length) {
        return [...elems];
    } else {
        throw new Error(`not found. selector: ${selector}`);
    }
};

/**
 * 選択されたセレクターに対応する最初の要素を返す。
 *
 * @param selector セレクター
 * @param context ルートとする要素 指定されていない場合はdocument
 * @returns HTML要素
 */
export const pickElement = <T extends HTMLElement>(selector: string, context?: Element) => {
    const elem = (context ?? document).querySelector<T>(selector);
    if (elem) {
        return elem;
    } else {
        throw new Error(`not found. selector: ${selector}`);
    }
};
